import styled from 'styled-components';

export const ColorSquareStyled = styled.div`
  width: 24px;
  height: 24px;
  background-color: ${(props) => props.color};
  border-radius: 3px;
`;

export const ColorTextStyled = styled.p`
  margin: 0 0 0 8px;
`;

export const CellWrapperStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;
